import React from "react";
import HeroSection from "./Component/Hero/heroSection";
import ServiceSection from "./Component/Service/serviceSection";
import WhyChooseUsSection from "./Component/WhyChoose/chooseSection";
import AboutUs from "./Component/AboutUs/aboutSection";
import Footer from "../../components/Footer/footer";
import ProjectShowcase from "./Component/Projects/project";
import './home.css';

const HomePage = () => {
  return (
    <div className="home-screen-main-container-style">
      <HeroSection />
      <ServiceSection />
      <WhyChooseUsSection />
      <ProjectShowcase />
      <AboutUs />
      <Footer />
    </div>
  );
};

export default HomePage;
